import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DisplayInputComponent } from '@components';
import { Contract, Signature, User } from '@models';

@Component({
  selector: 'app-user-contract',
  standalone: true,
  imports: [CommonModule, DisplayInputComponent, MatTabGroup, MatTab, MatIcon],
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.scss'],
})
export class UserContractComponent implements OnInit {
  @Input() user: User | null = null;
  @Input() latestContract: Contract | null = null;

  public safeContractUrl: SafeResourceUrl = '';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.safeContractUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.contract?.fileUrl ?? ''
    );
  }

  public get signature(): Signature | undefined {
    return this.user?.contractSignature;
  }

  public get contract(): Contract | undefined {
    return this.signature?.contract;
  }

  public get signedOn(): string {
    return JSON.stringify(this.signature?.createdAt).substring(1, 11);
  }

  public get signatureOutOfDate(): boolean {
    return this.signature?.contractId !== this.latestContract?.id;
  }
}
